<template src="./ledgerAccountVue.template.html"></template>
<script>
  export default {
    name: "ledgerAccountComponent",
    props: [],
    data() {
      return {
       
      };
    },

    methods: {
      switchView() {
        if (this.listType === "list") this.listType = "card";
        else this.listType = "list";
      },
     

      exportToExcel: function () {
      },
     
     
     
    },

    computed: {
     
     
    },

    mounted() {
     console.log("ledgerAccount");
    }
  };
</script>
